import styled from "styled-components";

const YesNoQuestion = styled.div`
  padding-top: 16px;

  .subtitle {
    margin-top: 0.5rem;
    color: ${({ theme }) => theme.colors.base4};
  }
`;

export default YesNoQuestion;
